import {
  GET_COMPANY_BY_SLUG_FAIL,
  GET_COMPANY_BY_SLUG_REQUEST,
  GET_COMPANY_BY_SLUG_SUCCESS,
} from "../constants/companyConstants";

export const companyReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_COMPANY_BY_SLUG_REQUEST:
      return {
        ...state,
        company: null,
        companyLoading: true,
        companyError: "",
      };
    case GET_COMPANY_BY_SLUG_SUCCESS:
      return {
        ...state,
        companyLoading: false,
        company: payload,
        companyError: "",
      };
    case GET_COMPANY_BY_SLUG_FAIL:
      return {
        ...state,
        companyLoading: false,
        companyError: payload,
      };
    default:
      return state;
  }
};

